module.exports = __webpack_public_path__ + "img/avp_bck_alt_phablet@2x.b36f111.webp";